import { Component, Input, ViewEncapsulation,Output,EventEmitter } from "@angular/core";
import { BaseFilterCellComponent, FilterService } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor, FilterDescriptor } from "@progress/kendo-data-query";
import { ViewType } from "../../../core/Enums";
import { IDataEndPoint } from "../../../interfaces/IEntity";
import { IControlChangeEventArgs } from "../../../../common/formbuilder/IControlChangeEventArgs";
import { MfTableV2Component } from "../mf-table-v2.component";

@Component({
  selector: 'form-control-cell',
  encapsulation: ViewEncapsulation.None,
  styles: [`
td[kendogridfiltercell] {
  background-color: white;
padding:0px;
}
    ` ],
  template: `
<form  #htmlForm="ngForm" style="width:100%;color:rgba(0, 0, 0, 0.87)" (keydown.enter)="$event.preventDefault()" > 
        <app-mf-form-control [formField]="formField" floatLabel="never" [displayLabel]="false" [(data)]="data" [formReadOnly]='false' isFilters="true" formControlPrefix='filters' 
        (onControlDataChange)="onControlDataChange($event)" [loading]='loading'
></app-mf-form-control>
</form>
      
    `
})
export class FormControlCell extends BaseFilterCellComponent {
  @Input()
  public formField: any;
  @Input()
  public filter: CompositeFilterDescriptor;
  @Input() public lazyLoad: boolean = true;
  @Input()
  public parent: MfTableV2Component;
  @Output() public dataChange = new EventEmitter();
  public loading: boolean;
  constructor(filterService: FilterService) {
    super(filterService);
  }
  public _data: any;
  public get data() {
    return this._data;
  }
  private onChangeTimeout: any;
  @Input() public set data(value) {
   
    var changed = false;
    changed = value != this._data;
    this._data = value;
    this.dataChange.emit(value)
    if (changed) {
      this.onChange(value);
    }
  }

  public ngAfterViewInit() {
    if (this.hasFilter && !this.data) {
      this._data = this.filtersByField(this.formField.field)[0].value
    }
  }

  public get hasFilter(): boolean {
    return this.filtersByField(this.formField.field).length > 0;
  }

  public clearFilter(): void {
    this.filterService.filter(
      this.removeFilter(this.formField.field)
    );
    this.data = null;
  }

  public onChange(value: any): void {
    if (!this.formField || !this.formField.controlType || (this.formField?.fieldOptions && this.formField?.fieldOptions.selectAllEndPoints)) {
      return;
    }
    if (this.formField.controlType.viewType == ViewType.DateTime && value) {
      this.filter = this.removeFilter(this.formField.field);
      if (value) {
        const filters = [];
        let start = new Date(value)["shortDate"]();
        let dat = new Date(value);
        var addDay = dat.setDate(dat.getDate() + 1);
        let end = new Date(addDay)["shortDate"]();

        if (start) {
          filters.push({
            field: this.formField.field,
            operator: "gte",
            value: start
          });
        }

        if (end) {
          filters.push({
            field: this.formField.field,
            operator: "lt",
            value: end
          });
        }

        const root = this.filter || {
          logic: "and",
          filters: []
        };

        if (filters.length) {
          root.filters.push(...filters);
        }

        this.filterService.filter(root);
      }
    }
    else if (this.formField.controlType.viewType == ViewType.CheckBox) {
      this.applyFilter(
        value === null ? // value of the default item
          this.removeFilter(this.formField.field) : // remove the filter
          this.updateFilter({ // add a filter for the field with the value
            field: this.formField.field,
            operator: 'eq',
            value: value
          })
      );
    }
    else if (this.formField.controlType.viewType == ViewType.Int || this.formField.controlType.viewType == ViewType.IntNoFormat) {
      this.applyFilter(
        value === null ? // value of the default item
          this.removeFilter(this.formField.field) : // remove the filter
          this.updateFilter({ // add a filter for the field with the value
            field: this.formField.field,
            operator: 'eq',
            value: value
          })
      );
    }
    else if (this.formField.controlType.viewType == ViewType.Dropdown) {
      this.applyFilter(
        value === null ? // value of the default item
          this.removeFilter(this.formField.field) : // remove the filter
          this.updateFilter({ // add a filter for the field with the value
            field: this.formField.field,
            operator: 'eq',
            value: value
          })
      );
    }
    else {
      this.applyFilter(
        value === null ? // value of the default item
          this.removeFilter(this.formField.field) : // remove the filter
          this.updateFilter({ // add a filter for the field with the value
            field: this.formField.field,
            operator: 'contains',
            value: value
          })
      ); // update the root filter
    }
  }

  private findByOperator(op: string): FilterDescriptor {
    return this.filtersByField(this.formField.field)
      .filter(({ operator }) => operator === op)[0];
  }

  public onControlDataChange(event: IControlChangeEventArgs) {

    let self = this;
    let col = <any>event.formBuilderControl.fieldOptions;
    if (col.selectAllEndPoints) {
      if (event.formBuilderControl.controlType.viewType == ViewType.CheckBox) {
        this.parent.selectAllChange(event.formBuilderControl.fieldOptions, event.controlValue, self)
        //let endPoint: IDataEndPoint = (col.endPoints.insert && event.controlValue) ? col.endPoints.insert : (col.endPoints.delete && !event.controlValue) ? col.endPoints.delete : null;
        //event.context.loading = true;
        //event.context.cdr.detectChanges();
        //if (endPoint) {
        //  self.apiService.exec({
        //    endPoint: endPoint,
        //    data: event.extraData,
        //    context: self,
        //    success: function (data) {
        //      event.context.loading = false;
        //      event.context.cdr.detectChanges();
        //      if (self.parent && self.parent.onBladeSave)
        //        self.parent.onBladeSave(self);
        //      if (self.parent && self.parent.updateLists)
        //        self.parent.updateLists();
        //    },
        //    error: function (error) {
        //      event.context.loading = false;
        //      event.context.data = !event.controlValue;
        //      event.context.cdr.detectChanges();
        //      self.messageService.error('Could not save', 'Action');
        //    }
        //  })
        //}
      }
    }
  }
}
